import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	theme => ({
		paper: {
			borderRadius: theme.spacing(2),
			border: `1px solid rgba(0, 0, 0, 0.08)`,
			boxShadow: '0px 8px 28px 0px rgba(0, 0, 0, 0.09)',
		},

		content: {
			display: 'flex',
			flexDirection: 'column',
			alignItems: ({ itemAlign }) => itemAlign?.contentAlignment(),
			marginTop: 2,
			padding: theme.spacing(3),
		},

		image: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: ({ itemAlign }) => itemAlign?.contentAlignment(),
			height: theme.spacing(8),
			width: '100%',
			maxWidth: theme.spacing(8),
			marginBottom: theme.spacing(2),

			'& img': {
				objectFit: 'contain',
				width: '100%',
				height: '100%',
			},
		},

		text: {
			textAlign: ({ itemAlign }) => itemAlign?.metaValue,
		},
	}),
	{ name: 'Category-Category6' },
)

export default useStyles
